(function($) {
	$(document).ready(function() {

		if ($('.team-filter').length) {

			function unserialize(serialize) {
			  var obj = {};
			  serialize = serialize.split('&');

			  for (var i = 0; i < serialize.length; i++) {
			    var thisItem = serialize[i].split('=');
			    obj[decodeURIComponent(thisItem[0])] = decodeURIComponent(thisItem[1]);
			  }

			  ;
			  return obj;
			}


			function unserialize(serialize) {
			  var obj = {};
			  serialize = serialize.split('&');

			  for (var i = 0; i < serialize.length; i++) {
			    var thisItem = serialize[i].split('=');
			    obj[decodeURIComponent(thisItem[0])] = decodeURIComponent(thisItem[1]);
			  };
			  return obj;
			}

			window.addEventListener('popstate', function(e) {
		      // e.state is equal to the data-attribute of the last image we clicked
		      console.log(e);
		      if (e.state[0] == 'paginate') {
						var targetData = window.location.search.substring(1);
		        console.log('History targetData: '+targetData);
		        if (targetData.length > 0) {
		          var dropdownUpdate = unserialize(targetData);
		          for (var key in dropdownUpdate) {
		              var value = dropdownUpdate[key];
		              if ($('#'+key).length && $('#'+key).val() != value) {
		                $('#'+key).val(value).trigger('change.select2');
		                console.log('Change dropdown '+key+' without action');
		              }
		          }
		        } else {
		          $('.team-filter form select').each(function(){
		            $(this).val('0').trigger('change.select2');
		            console.log('Reset dropdowns without action');
		          });
		        }
						$('.team-filter form').submit();
		      }
		  });

	    var l = window.location.href;
	    var historyData = new Array();
	    historyData.push('paginate');
	    historyData.push(l);
	    history.pushState(historyData, null, l);



			var activeAction = '',
				newScrollDate = new Date(),
				oldScrollDate = new Date(),
				scrollWheel = 0,
				checkScrollAllowed = true;

			$('.team-filter select[name="team-division"]').on('change', function(ev) {
				$('.team-filter select[name="team_name"]').val('0');
	 			ev.preventDefault();

				var targetData = $('.team-filter form').serialize();
				console.log('targetData = '+targetData);
	      historyData = [];
	      historyData.push('paginate');
	      historyData.push('./?'+targetData);
	      history.pushState(historyData, null, './?'+targetData);

				$('.team-filter form').submit();


	      // var targetData = $(this).attr('name')+'='+$(this).find(":selected").val();
				// console.log('targetData = '+targetData);
	      // historyData = [];
	      // historyData.push('paginate');
	      // historyData.push('./?'+targetData);
	      // history.pushState(historyData, null, './?'+targetData);
				//
				//
				// if ($(this).find(":selected").val() != '0') {
		 		// 	$('#ppl-container').data('division', $(this).find(":selected").val());
		 		// 	$('#ppl-container').attr('class','').addClass( $(this).find(":selected").val() );
		 		// 	activeAction = 'filter-people';
				//
		 		// 	teamFilter();
				// } else {
				// 	$('#ppl-container').html('');
				// }
	 		});

			// var targetData = window.location.search.substring(1);
			// console.log(targetData);
			// if (targetData) {
			// 	if ($('.team-filter select[name="team-division"]').val() != '0')
			// 		$('.team-filter select[name="team-division"]').trigger('change');
			// 	if ($('.team-filter select[name="team_location"]').val() != '0')
			// 		$('.team-filter select[name="team_location"]').trigger('change');
			// }
			$('.team-filter select[name="team_location"]').parents('.custom-select').addClass('hide');
			$('.team-filter select[name="team_location"]').on('change', function(ev) {

				ev.preventDefault();

				var targetData = $('.team-filter form').serialize();
				console.log('targetData = '+targetData);
	      historyData = [];
	      historyData.push('paginate');
	      historyData.push('./?'+targetData);
	      history.pushState(historyData, null, './?'+targetData);

				$('.team-filter form').submit();


	      // var targetData = $(this).attr('name')+'='+$(this).find(":selected").val();
				// console.log('targetData = '+targetData);
	      // historyData = [];
	      // historyData.push('paginate');
	      // historyData.push('./?'+targetData);
	      // history.pushState(historyData, null, './?'+targetData);
				//
				//
				// if ($(this).find(":selected").val() != '0') {
		 		// 	$('#ppl-container').data('location', $(this).find(":selected").val());
		 		// 	$('#ppl-container').attr('class','').addClass( $(this).find(":selected").val() );
		 		// 	activeAction = 'filter-people';
				//
		 		// 	teamFilter();
				// } else {
				// 	$('#ppl-container').html('');
				// }
	 		});

			$('.team-filter select[name="team_name"]').on('change', function(ev) {
	 			ev.preventDefault();

				// $('.team-filter select[name="team-division"]').val('0');
	 			// $('#ppl-container').data('search', $(this).find(":selected").val());
	 			// $('#ppl-container').attr('class','').addClass( $(this).find(":selected").val() );
	 			// activeAction = 'filter-people';
	 			// teamFilter();
				window.location = '/our-team/'+$(this).find(":selected").val();
	 		});

			// $('.team-filter select[name="team_title"]').on('change', function(ev) {
	 		// 	ev.preventDefault();
	 		// 	$('#ppl-container').data('title', $(this).find(":selected").val());
	 		// 	$('#ppl-container').attr('class','').addClass( $(this).find(":selected").val() );
	 		// 	activeAction = 'filter-people';
	 		// 	teamFilter();
	 		// });

			$('.team-filter form').on('submit', function(ev) {
				ev.preventDefault();



				$('#ppl-container').attr('class','');
				var action = false;
				if ($('.team-filter select[name="team-division"]').find(":selected").val() != '0') {
		 			$('#ppl-container').data('division', $('.team-filter select[name="team-division"]').find(":selected").val());
		 			$('#ppl-container').addClass( $('.team-filter select[name="team_location"]').find(":selected").val() );
					action = true;
				}
				if ($('.team-filter select[name="team_location"]').find(":selected").val() != '0') {
		 			$('#ppl-container').data('location', $('.team-filter select[name="team_location"]').find(":selected").val());
		 			$('#ppl-container').addClass( $('.team-filter select[name="team_location"]').find(":selected").val() );
					action = true;
				}
				if (action) {
		 			activeAction = 'filter-people';
		 			teamFilter();
				} else {
					$('#ppl-container').html('');
				}
				if ($('.team-filter select[name="team-division"]').val() == 'management-committee' || $('.team-filter select[name="team-division"]').val() == 'team') {
					$('.team-filter select[name="team_location"]').parents('.custom-select').removeClass('hide');
				} else {
					$('.team-filter select[name="team_location"]').val('0').trigger('change.select2').parents('.custom-select').addClass('hide');
				}

	 		});
			$('.team-filter form .reset').on('click',function(e){
				e.preventDefault();
				// var textField = $('.team-filter form .search-filter input[type="text"]');
				// textField.val('');
				// textField.attr("placeholder", 'Name');
	 			// $('#ppl-container').data('search', textField.val());
				$('.team-filter select[name="team_location"]').parents('.custom-select').addClass('hide');
				$('.team-filter select').val('0').trigger('change.select2');
				$('#ppl-container').html('');
				$('#ppl-container').data('division','');
				$('#ppl-container').data('location','');
				$('#ppl-container').data('title','');
				var l = window.location.href.split('?')[0];
		    var historyData = new Array();
		    historyData.push('paginate');
		    historyData.push(l);
		    history.pushState(historyData, null, l);
			});

			$(window).bind("pageshow", function() {
				// $('.team-filter select[name="team-division"]').val('team').trigger('change');
		    // $('.team-filter form').submit();
				// console.log('submitting filter');
			});


	 		$('#morePeople').on('click', function(ev) {
	 			ev.preventDefault();
	 			activeAction = 'load-people';
	 			$('#ppl-container').data('division','team');
	 			teamFilter();
	 			$('#morePeople').off('click');
	 		});


			var targetData = window.location.search.substring(1);
			console.log('pageload targetData: '+targetData);
			if (targetData) {
				var dropdownUpdate = unserialize(targetData);
				for (var key in dropdownUpdate) {
						var value = dropdownUpdate[key];
						if ($('#'+key).length && $('#'+key).val() != value) {
							$('#'+key).val(value).trigger('change.select2');
							console.log('Change dropdown '+key+' without action');
						}
				}
			} else {
				$('.filter select').each(function(){
					$(this).val('').trigger('change.select2');
					console.log('Resert dropdowns without action');
				});
			}

			$('.team-filter form').submit();
		}



 		function teamFilter() {

 			var button = $('#morePeople'),
 				currentPage = $('#ppl-container').data('currentpage'),
 				maxPages = $('#ppl-container').data('maxpages'),
 				division = $('#ppl-container').data('division'),
 				title = $('#ppl-container').data('title'),
 				location = $('#ppl-container').data('location'),
 				search = $('#ppl-container').data('search');


 			$.ajax({
				url: filter_people_obj.ajaxurl,
				type: 'post',
				data: {
					action: activeAction,
					'post_type' : 'our-team',
					'page' : currentPage,
					'max_page' : maxPages,
					'division' : division,
					'location' : location,
					'title' : title,
					'search' : search
				},
				beforeSend: function() {
					$('#maxPages').remove();
					console.log(activeAction);
					//if(activeAction == 'load-people') {
						$('.team-filter-container #ppl-container').find('li').remove();
					//}
						$('.team-filter-container').removeClass('empty');
					$('#loading-icon').show();

				},
				success: function( result ) {
					if( result ) {
						$('.team-filter-container #ppl-container').append(result);
						$('#ppl-container li a').each(function(){
							var link = $(this).attr('href');
							$(this).attr('href',link+'?fl=true');
						});

						if(division == "senior-advisory-board") {
							$("#ppl-container").find("h4:contains('Richard Hayden')").parents('li').prependTo('#ppl-container');
						}
						if (division == 'senior-advisory-board' || division == 'impact-advisory-board' || division == 'management-advisory-board' || division == 'delta-advisory-board') {
							$('#ppl-container .image-wrapper').addClass('hide');
						}

						if(division == 'management-committee') {
							if ( $('html').attr('lang') == 'en-GB' ) {
								console.log('UK');
								$("#ppl-container").find("h4:contains('Jonathan Bilzin')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Karim Saddi')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Neal Moszkowski')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Ramez Sousou')").parents('li').prependTo('#ppl-container');
							} else {
								console.log('US');
								$("#ppl-container").find("h4:contains('Karim Saddi')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Jonathan Bilzin')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Ramez Sousou')").parents('li').prependTo('#ppl-container');
								$("#ppl-container").find("h4:contains('Neal Moszkowski')").parents('li').prependTo('#ppl-container');
							}
						}

						if( search ) {
							$(".team a img").hide();
						}

						if(activeAction == 'load-people') {
							currentPage++;
						} else {
							currentPage = 1;
							maxPages = $('.team-filter-container #ppl-container').data('maxpages');
							$('.team-filter-container #ppl-container').data('maxpages', maxPages);
						}

						$('.team-filter-container #ppl-container').data('currentpage', currentPage);
						if ( currentPage >= maxPages ) {
							button.hide();
						} else {
							button.show();
						}
						$('.team-filter-container #ppl-container li .details').matchHeight({remove : false, });

						clearTimeout(resetButton);
						var resetButton = setTimeout(function() {
							button.off('click');
							button.on('click', function(ev) {
					 			ev.preventDefault();
					 			activeAction = 'filter-people';
					 			teamFilter();
					 			$('#morePeople').off('click');
					 		});
						});


					} else {
						button.hide();
					}
				},
				complete: function() {
					$('#loading-icon').slideUp();
				}
			});
		}

	});
})(jQuery);
